import { Grid, Popover } from '@material-ui/core';
import { Button, Icons, Typography } from '@nutrien/cxp-components';
import React from 'react';

import { SORT_BY_ASC, SORT_BY_DESC } from '../../utilities/constants';
import { FieldInspectorTab, LeadInspectorTab } from '../../utilities/enums';
import useStyles from './InspectionListSortBy.styles';

interface Props {
  open: boolean;
  tabValue: number;
  anchorEl: HTMLDivElement | null;
  handleClose: () => void;
  inspectionId: string;
  inspectionName: string;
  needAttention: string;
  inspectionLevel: string;
  handleInspectionIdClick: () => void;
  handleInspectionNameClick: () => void;
  handleNeedAttentionClick: () => void;
  handleInspectionLevelClick: () => void;
  isAssignToLead: boolean;
}

const InspectionListSortBy: React.FC<Props> = ({
  open,
  tabValue,
  anchorEl,
  handleClose,
  inspectionId,
  inspectionName,
  needAttention,
  inspectionLevel,
  handleInspectionIdClick,
  handleInspectionNameClick,
  handleNeedAttentionClick,
  handleInspectionLevelClick,
  isAssignToLead,
}) => {
  const classes = useStyles();

  return (
    <Popover
      id="sortBy"
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      classes={{ paper: classes.paper }}
    >
      <Grid className={classes.outerGrid}>
        <Grid>
          <Grid item xs={12} className={`${inspectionId !== '' ? classes.sortElement : ''}`}>
            <Button
              variant="text"
              color="white"
              noMinHeight
              onClick={handleInspectionIdClick}
              className={classes.fullWidth}
            >
              <Typography
                className={`${classes.textStyle} ${
                  inspectionId !== '' ? `${classes.textStyleBg1}` : `${classes.textStyleBg2}`
                }`}
              >
                Inspection ID
              </Typography>
              <Typography className={classes.iconStyle}>
                {inspectionId === SORT_BY_ASC && <Icons.ArrowUpFeather color="primary" />}
                {inspectionId === SORT_BY_DESC && <Icons.ArrowDownFeather color="primary" />}
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={12} className={`${inspectionName !== '' ? classes.sortElement : ''}`}>
            <Button
              variant="text"
              color="white"
              noMinHeight
              className={classes.fullWidth}
              onClick={handleInspectionNameClick}
            >
              <Typography
                className={`${classes.textStyle} ${
                  inspectionName !== '' ? `${classes.textStyleBg1}` : `${classes.textStyleBg2}`
                }`}
              >
                Inspection Name
              </Typography>
              <Typography className={classes.iconStyle}>
                {inspectionName === SORT_BY_ASC && <Icons.ArrowUpFeather color="primary" />}
                {inspectionName === SORT_BY_DESC && <Icons.ArrowDownFeather color="primary" />}
              </Typography>
            </Button>
          </Grid>
          {tabValue !==
          (!isAssignToLead ? FieldInspectorTab.UNASSIGN : LeadInspectorTab.UNASSIGN) ? (
            <Grid item xs={12} className={`${needAttention !== '' ? classes.sortElement : ''}`}>
              <Button
                variant="text"
                color="white"
                noMinHeight
                className={classes.fullWidth}
                onClick={handleNeedAttentionClick}
              >
                <Typography
                  className={`${classes.textStyle} ${
                    needAttention !== '' ? `${classes.textStyleBg1}` : `${classes.textStyleBg2}`
                  }`}
                >
                  Need Attention
                </Typography>
                <Typography className={classes.iconStyle}>
                  {needAttention === SORT_BY_ASC && <Icons.ArrowUpFeather color="primary" />}
                  {needAttention === SORT_BY_DESC && <Icons.ArrowDownFeather color="primary" />}
                </Typography>
              </Button>
            </Grid>
          ) : (
            ''
          )}
          <Grid item xs={12} className={`${inspectionLevel !== '' ? classes.sortElement : ''}`}>
            <Button
              variant="text"
              color="white"
              noMinHeight
              className={classes.fullWidth}
              onClick={handleInspectionLevelClick}
            >
              <Typography
                className={`${classes.textStyle} ${
                  inspectionLevel !== '' ? `${classes.textStyleBg1}` : `${classes.textStyleBg2}`
                }`}
              >
                Inspection Level
              </Typography>
              <Typography className={classes.iconStyle}>
                {inspectionLevel === SORT_BY_ASC && <Icons.ArrowUpFeather color="primary" />}
                {inspectionLevel === SORT_BY_DESC && <Icons.ArrowDownFeather color="primary" />}
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Popover>
  );
};

export default InspectionListSortBy;
